import { EpiLink } from '@api/types';
import { BlockProperty, SmartLink } from '@components';
import { Box, styled, Typography } from '@mui/material';
import { ReactNode } from 'react';

export interface LinkListBlockProps {
  title?: ReactNode;
  titlePropertyName?: string;
  links?: EpiLink[];
  linksPropertyName?: string;
  disableEditPanel?: boolean;
}

const Wrapper = styled('div')``;

const Title = styled(Typography)`
  font-weight: 700;
  font-size: 20px;
  margin-bottom: 24px;
`;

export const LinkListBlock = ({
  title,
  titlePropertyName = '',
  links = [],
  linksPropertyName = '',
}: LinkListBlockProps) => {
  return (
    <Wrapper>
      <BlockProperty property={titlePropertyName}>
        <Title>{title}</Title>
      </BlockProperty>
      <BlockProperty property={linksPropertyName}>
        {links.map((link: EpiLink, index: number) => (
          <Box key={index}>
            <Box component='span'>
              <SmartLink {...link} sx={{ display: 'inline-block' }} />
            </Box>
          </Box>
        ))}
      </BlockProperty>
    </Wrapper>
  );
};
